export default {
	// SET
	SET_AUTHENTICATED(state, payload) {
		state.authenticated = payload;
		localStorage.setItem("isAuthenticated", payload);
	},
	SET_USER_ID(state, payload) {
		state.user = payload;
		localStorage.setItem("userId", JSON.stringify(payload));
	},
	SET_TOKEN(state, payload) {
		state.token = payload;
		localStorage.setItem("accessToken", JSON.stringify(payload));
	},
	SET_USER_NAME(state, payload) {
		state.userName = payload;
		localStorage.setItem("userName", JSON.stringify(payload));
	},
	SET_USER_EMAIL(state, payload) {
		state.userEmail = payload;
		localStorage.setItem("userEmail", JSON.stringify(payload));
	},
	SET_USER_DATE_OF_BIRTH(state, payload) {
		state.userDateOfBirth = payload;
		localStorage.setItem("userDateOfBirth", JSON.stringify(payload));
	},
	SET_USER_DATA(state, payload) {
		state.userData = payload;
		localStorage.setItem("userData", JSON.stringify(payload));
	},
	SET_TOKEN_EXPIRATION(state, payload) {
		state.tokenExpiration = payload;
		localStorage.setItem("tokenExpiration", JSON.stringify(payload));
	},
	SET_IS_SUPER_ADMIN(state, payload) {
		state.isSuperAdmin = payload;
		localStorage.setItem("isSuperAdmin", JSON.stringify(payload));
	},
	SET_IS_TREASURER(state, payload) {
		state.isTreasurer = payload;
		localStorage.setItem("isTreasurer", JSON.stringify(payload));
	},
	SET_IS_TREASURER_ADD_CLIENT(state, payload) {
		state.isTreasurerAddClient = payload;
		localStorage.setItem("isTreasurerAddClient", JSON.stringify(payload));
	},
	SET_TREASURER_ACCOUNTS(state, payload) {
		state.treasurerAccounts = payload;
		localStorage.setItem("treasurerAccounts", JSON.stringify(payload));
	},
	SET_CONSULTANT_FUNDRAISER_ACCOUNTS(state, payload) {
		state.consultantFundraiserAccounts = payload;
		localStorage.setItem("consultantFundraiserAccounts", JSON.stringify(payload));
	},
	SET_IS_LOGIN_FROM_OLD_UI(state, payload) {
		state.isLoginFromOldUI = payload;
		localStorage.setItem("isLoginFromOldUI", JSON.stringify(payload));
	},
	SET_REDIRECT_URL(state, payload) {
		state.redirectUrl = payload;
		localStorage.setItem("redirectUrl", JSON.stringify(payload));
	},
	// LOG(state, payload) {
	// 	let entry = {
	// 		eventTime: new Date(),
	// 		message: payload,
	// 	};
	// 	state.log.push(entry);
	// 	localStorage.setItem("log", JSON.stringify(state.log));
	// },

	// REMOVE
	REMOVE_AUTHENTICATED(state) {
		state.authenticated = false;
		localStorage.removeItem("isAuthenticated");
	},
	REMOVE_USER(state) {
		state.user = null;
		localStorage.removeItem("userId");
	},
	REMOVE_TOKEN(state) {
		state.token = "payload";
		localStorage.removeItem("accessToken");
	},
	REMOVE_TOKEN_EXPIRATION(state) {
		state.tokenExpiration = null;
		localStorage.removeItem("tokenExpiration");
	},
	REMOVE_IS_SUPER_ADMIN(state) {
		state.isSuperAdmin = false;
		localStorage.removeItem("isSuperAdmin");
	},
	REMOVE_IS_TREASURER(state) {
		state.isTreasurer = false;
		localStorage.removeItem("isTreasurer");
	},
	REMOVE_IS_TREASURER_ADD_CLIENT(state) {
		state.isTreasurerAddClient = false;
		localStorage.removeItem("isTreasurerAddClient");
	},
	REMOVE_IS_LOGIN_FROM_OLD_UI(state) {
		state.isLoginFromOldUI = false;
		localStorage.removeItem("isLoginFromOldUI");
	},
	REMOVE_TREASURER_ACCOUNTS(state) {
		state.treasurerAccounts = null;
		localStorage.removeItem("treasurerAccounts");
	},
	REMOVE_CONSULTANT_FUNDRAISER_ACCOUNTS(state) {
		state.consultantFundraiserAccounts = null;
		localStorage.removeItem("consultantFundraiserAccounts");
	},
	REMOVE_USER_NAME(state) {
		state.userName = null;
		localStorage.removeItem("userName");
	},
	REMOVE_USER_EMAIL(state) {
		state.userEmail = null;
		localStorage.removeItem("userEmail");
	},
	REMOVE_USER_DATE_OF_BIRTH(state) {
		state.userDateOfBirth = null;
		localStorage.removeItem("userDateOfBirth");
	},
	REMOVE_REDIRECT_URL(state) {
		state.redirectUrl = null;
		localStorage.removeItem("redirectUrl");
	},
};
